export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14366.3d34e4ef.jpg";